import { Check, Close } from '@mui/icons-material'
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Grid,
  MenuItem,
} from '@mui/material'
import { CountryCode } from 'api/models/GetAddress.type'
import { CountrySelect } from 'components/Common/CountrySelect/CountrySelect'
import notifyPopup from 'components/Common/Notification/notifyPopup'
import RadioSwitch from 'components/FormFields/RadioSwitch/RadioSwitch'
import Select from 'components/FormFields/Select/Select'
import Form from 'components/RouteWizard/Form'
import useSupplier from 'hooks/useSupplier'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import Input from '../../../FormFields/Input/Input'
import styles from './billingStyle'
import schema from './schema'

function Billing({ supplierData }: any) {
  console.log(supplierData)
  const supplier = supplierData.payload
  const { updateSupplier, error, isLoading } = useSupplier()
  const [errors, setErrors] = useState<Record<string, string | undefined>>({})
  const [formData, setFormData] = useState({ ...supplier.billing })
  const [editForm, setEditForm] = useState(false)

  function setDeepValue(obj: any, path: any, value: any): any {
    const keys = path.split('.')
    const [firstKey, ...restKeys] = keys
    if (restKeys.length === 0) {
      return { ...obj, [firstKey]: value }
    }
    return {
      ...obj,
      [firstKey]: setDeepValue(obj[firstKey] || {}, restKeys.join('.'), value),
    }
  }
  const onChange = (eOrValue: any) => {
    let fieldName = null
    if (
      eOrValue &&
      typeof eOrValue === 'object' &&
      'target' in eOrValue &&
      typeof eOrValue.target === 'object' &&
      eOrValue.target !== null &&
      'name' in eOrValue.target &&
      'value' in eOrValue.target
    ) {
      const { name, value } = eOrValue.target
      fieldName = name
      setFormData((prev: any) => setDeepValue({ ...prev }, name, value))
    } else if (
      eOrValue &&
      typeof eOrValue === 'object' &&
      eOrValue.name !== undefined &&
      eOrValue.value !== undefined
    ) {
      fieldName = eOrValue.name
      setFormData((prev: any) =>
        setDeepValue({ ...prev }, eOrValue.name, eOrValue.value),
      )
    } else if (typeof eOrValue === 'string') {
      fieldName = 'address.countryCode'
      let updated = setDeepValue(
        { ...formData },
        'address.countryCode',
        eOrValue,
      )
      updated = setDeepValue(
        updated,
        'address.country',
        CountryCode[eOrValue as keyof typeof CountryCode] || '',
      )
      setFormData(updated)
    }

    // Clear error for this field
    if (fieldName && errors[fieldName]) {
      setErrors((prev) => ({ ...prev, [fieldName]: undefined }))
    }
  }

  useEffect(() => {
    console.log('changedFormData', formData)
  }, [formData])

  const onSubmit = () => {
    setEditForm(false)
    updateSupplier({ billing: formData }, supplier.id).then(() => {
      notifyPopup({
        type: error ? 'danger' : 'success',
        message: error
          ? 'Update failed to save'
          : 'Details updated successfully',
      })
    })
  }

  return (
    supplierData && (
      <Form
        schema={schema}
        onSubmit={onSubmit}
        defaultValues={formData}
        showControls={false}
      >
        <Grid container>
          <Grid container sx={styles.leftHeading}>
            <Grid item xs={12} sm={8}>
              <FormLabel>Payment Details</FormLabel>
            </Grid>
          </Grid>

          <Grid container sx={{ width: '50%' }} rowSpacing={2}>
            <Grid item xs={12} sm={10}>
              <Input
                label="Account Holder"
                name="payment.accountHolderName"
                value={formData.payment?.accountHolderName || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input
                label="Account Number"
                name="payment.accountNumber"
                value={formData.payment?.accountNumber || ''}
                onChange={onChange}
                InputLabelProps={{ shrink: true }}
                disabled={!editForm}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Input
                label="Sort Code"
                name="payment.sortCode"
                value={formData.payment?.sortCode || ''}
                onChange={onChange}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={!editForm}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} sm={1}>
              <FormControl
                sx={{ ...styles.formControl, marginTop: '15px' }}
                disabled={!editForm}
              >
                <RadioSwitch
                  options={[
                    { value: 'true', label: <Check /> },
                    { value: 'false', label: <Close /> },
                  ]}
                  disabled={!editForm}
                  onChange={(e) => {
                    if (editForm) {
                      onChange({
                        name: 'vatRegistered',
                        value: e.target.value === 'true',
                      })
                    }
                  }}
                  displayMode="compact"
                  value={String(formData.vatRegistered)}
                  label={<>VAT Registered</>}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              {formData.vatRegistered && (
                <Input
                  label="VAT Number"
                  name="vatNumber"
                  value={formData.vatNumber || ''}
                  onChange={onChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={!editForm}
                />
              )}
            </Grid>
          </Grid>
          <Grid container sx={styles.leftHeading}>
            <Grid item xs={12} sm={8}>
              <FormLabel>Payment Terms</FormLabel>
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ width: '70%' }}>
            <Grid item xs={12} sm={4}>
              <Select
                id="paymentTermSelect"
                disabled={!editForm}
                label="Payment Term"
                name="billingTermTypeName"
                value={formData.billingTermTypeName}
                onChange={onChange}
                sx={styles.background}
              >
                <MenuItem value={'EndOfMonth'}>
                  End of month following date of invoice
                </MenuItem>
                <MenuItem value={'DaysFromInvoice'}>
                  Days from date of invoice
                </MenuItem>
              </Select>
            </Grid>
            {formData.billingTermTypeName === 'DaysFromInvoice' ? (
              <Grid item xs={12} sm={4}>
                <Input
                  label="Number of Days"
                  name="billingTermValue"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.billingTermValue || ''}
                />
              </Grid>
            ) : null}
          </Grid>
          <Grid container spacing={1} sx={styles.leftHeading}>
            <Grid item xs={12} sm={4}>
              <FormLabel>Billing Address</FormLabel>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormLabel>Billing Contact</FormLabel>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item sm={4}>
              <Grid item xs={12} sm={10}>
                <Input
                  label="Billing Name"
                  name="entity"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.entity || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Input
                  label="Street Address"
                  name="address.addressLine1"
                  sx={styles.background}
                  onChange={onChange}
                  disabled={!editForm}
                  value={formData.address?.addressLine1 || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Input
                  label="Street Address 2"
                  name="address.addressLine2"
                  sx={styles.background}
                  onChange={onChange}
                  disabled={!editForm}
                  value={formData.address?.addressLine2 || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Input
                  label="Town"
                  name="address.town"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.address?.town || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Input
                  label="County"
                  name="address.county"
                  sx={styles.background}
                  onChange={onChange}
                  disabled={!editForm}
                  value={formData.address?.county || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Input
                  label="Post / Zip Code"
                  name="address.postCode"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.address?.postCode || ''}
                />
              </Grid>
              <Grid item xs={12} sm={10}>
                <FormControl variant="outlined" sx={{ display: 'none' }}>
                  <Input
                    label="Country"
                    name="address.country"
                    sx={styles.background}
                    disabled={!editForm}
                    value={formData.address?.country || ''}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={10}>
                <CountrySelect
                  label="Country"
                  name="address.countryCode"
                  onChange={onChange}
                  disabled={!editForm}
                  value={formData.address?.countryCode || ''}
                  sibling="address.country"
                  sx={styles.formControl}
                />
              </Grid>
            </Grid>
            <Grid item sm={5}>
              <Grid item xs={12} sm={8}>
                <Input
                  label="Contact Name"
                  name="contact.name"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.contact?.name || ''}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Input
                  label="Contact Email"
                  name="contact.email"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.contact?.email || ''}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Input
                  label="Contact Number"
                  name="contact.contactNumber"
                  onChange={onChange}
                  sx={styles.background}
                  disabled={!editForm}
                  value={formData.contact?.contactNumber || ''}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={8} sx={styles.fieldSpacing}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginTop: '20px',
              gap: '10px',
            }}
          >
            <Button
              color={editForm ? 'error' : 'primary'}
              onClick={() => setEditForm(!editForm)}
            >
              {!editForm ? 'Edit' : 'Cancel'}
            </Button>
            {editForm && (
              <Button type="submit" color="success" disabled={isLoading}>
                Save
              </Button>
            )}
          </Box>
        </Grid>
      </Form>
    )
  )
}

Billing.propTypes = {
  client: PropTypes.object.isRequired,
}

export default Billing
